import React from 'react';

import Stories from '../../components/Stories';

export default function Home() {
  return <Stories />;
}
